import { NgModule } from '@angular/core';
import { TranslationButtonComponent } from './translation-button.component';

@NgModule({
  imports: [],
  declarations: [TranslationButtonComponent],
  exports: [TranslationButtonComponent],
})
export class TranslationButtonModule {}
